
/**
 * Enhances stage cards in the cloned document
 */
export const enhanceStageCardsInDocument = (clonedDoc: Document): void => {
  // Enhance stage cards
  const clonedCards = clonedDoc.querySelectorAll('.stage-card');
  clonedCards.forEach(card => {
    if (card instanceof HTMLElement) {
      // Apply crisp rendering to stage cards
      card.style.backgroundColor = 'white';
      card.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.25)';
      card.style.border = '1px solid #d1d5db';
      card.style.borderRadius = '8px';
      card.style.filter = 'none'; // Remove any filter effects that might cause blurriness
      card.style.transform = 'translateZ(0)'; // Force hardware acceleration
      
      // Ensure consistent fonts and sizing across cards
      card.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
      
      // Apply better rendering for text elements inside cards
      const textElements = card.querySelectorAll('p, div, h3, span');
      textElements.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.textRendering = 'optimizeLegibility';
          el.style.setProperty('-webkit-font-smoothing', 'antialiased');
          el.style.setProperty('-moz-osx-font-smoothing', 'grayscale');
        }
      });
    }
  });
  
  // Ensure journey content container has white background
  const journeyContent = clonedDoc.querySelector('.relative.bg-white.dark\\:bg-gray-800, .bg-white.dark\\:bg-gray-800');
  if (journeyContent instanceof HTMLElement) {
    journeyContent.style.backgroundColor = 'white';
    journeyContent.style.color = '#111827';
    journeyContent.style.filter = 'none'; // Remove any filter effects
  }
  
  // Fix quote bubbles for consistency
  const quoteBubbles = clonedDoc.querySelectorAll('.bg-gray-100');
  quoteBubbles.forEach(bubble => {
    if (bubble instanceof HTMLElement) {
      bubble.style.backgroundColor = '#f3f4f6';
      bubble.style.color = '#333333';
      bubble.style.border = '1px solid #e5e7eb';
    }
  });
  
  // Ensure consistent styling for stage sections (description, pain points, opportunities)
  const stageSections = clonedDoc.querySelectorAll('.stage-card .text-xs.font-medium, .stage-card .min-h-\\[2\\.5rem\\]');
  stageSections.forEach(section => {
    if (section instanceof HTMLElement) {
      if (section.classList.contains('font-medium')) {
        // Section headers
        section.style.color = '#000000';
        section.style.fontWeight = '600';
      } else {
        // Section content
        section.style.color = '#333333';
        section.style.fontStyle = 'normal'; // Remove italics for better readability
        section.style.opacity = '1';
      }
    }
  });
}
